import React, {useState} from 'react';
import platforms from '../data/platforms.json'; // Assuming you have a platforms.json file with the links
import productData from "../data/products.json";

const ImportantLinks = () => {
    const [products] = useState(productData.products);
  return (
    <div className="w-full min-h-screen p-6 bg-gray-50 text-gray-900">
      <h1 className="text-2xl font-bold mb-4 text-gray-800">Important Links</h1>

      {/* Social Media Links */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Follow Us on Social Media</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Instagram: <a href="https://instagram.com/shinzuracare" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://instagram.com/shinzura</a>
          </li>
          <li>
            Facebook: <a href="https://www.facebook.com/profile.php?id=61573879312290" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://facebook.com/shinzura</a>
          </li>
          <li>
            X.com (Twitter) : <a href="https://x.com/Shinzura_in" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://x.com/Shinzura_in</a>
          </li>
          <li>
            Linkedin: <a href="https://www.linkedin.com/in/shinzura/" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://www.linkedin.com/in/shinzura/</a>
          </li>
          <li>
            YouTube: <a href="https://www.youtube.com/@Shinzura_care" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://youtube.com/@shinzura</a>
          </li>
          <li>
            Pinterest: <a href="https://in.pinterest.com/shinzuracare/" className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">https://in.pinterest.com/shinzuracare/</a>
          </li>
        </ul>
      </section>

      {/* E-commerce Platform Links */}
      <section className="mb-10">
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Buy Shinzura Products Online</h2>
        <ul className="list-disc pl-6 space-y-2">
            {platforms.map((platform) => (
            <li key={platform.name}>
                {platform.name}: <a href={platform.link} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">{platform.link}</a>
            </li>
            ))}
        </ul>
      </section>

      {/* Product Links */}
      <section>
        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Our Popular Products</h2>
        <ul className="list-disc pl-6 space-y-2">
        {products.map((product) => (
            <li key={product.id}>
          {product.title}: <a href={`/products/${product.str}`} className="text-blue-600 underline" target="_blank" rel="noopener noreferrer">{`/products/${product.str}`}</a>
          </li>
        ))}
         
        </ul>
      </section>
    </div>
  );
};

export default ImportantLinks;
